<ul class="list-unstyled u-mb0 left-right-list left-right-list--metadata">
  <li
    *ngIf="resourceType"
    class="left-right-list__entry qa-resource-metadata__type"
  >
    <div i18n="@@resourceMetadata-label-type">Type</div>
    <div>
      <rl-bibliographic-resource-type
        [resourceType]="resourceType"
      ></rl-bibliographic-resource-type>
    </div>
  </li>

  <ng-container *ngFor="let item of metadata">
    <li class="left-right-list__entry">
      <div>{{ item.title }}</div>
      <div>{{ item.description }}</div>
    </li>
  </ng-container>
</ul>
